<template lang="pug">
  .cancel-reasons
    SectionBlock(no-padding=true)
      transition(name="fade")
        .cancel-wrap(data-mr-ass="more-color-at-home")
          .back-row
            BackButton(:url="backUrl")

          SectionTitle(text="Cancel Subscription").text-center

          ColorCrewContact Have more color than you need at home? You can go longer between boxes or pause until you need more.

          .other-options
            p.other-options.color-slate.text-center.xs-f-small.lg-f-medium.max-at-tweak Or, easily customize your schedule...

            ActionButton(title="Choose ship date" descr="When do you need your next box?" @action-btn-click="chooseShipDate")
            ActionButton(title="Pause subscription" descr="Pause shipments for up to six months" @action-btn-click="pauseSub")

          CancelSubBtn(data-mr-ass="cancel-sub-button")

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import SectionBlock from "../../SectionBlock";
  import BackButton from "../../BackButton";
  import SubInEdit from './SubInEdit';
  import SectionTitle from "../../../SectionTitle";
  import ColorCrewContact from "./ColorCrewContact";
  import ActionButton from "./ActionButton";
  import CancelSubBtn from "./CancelSubBtn";
  import zendeskTag from "../../../../mixins/zendeskTag";

  export default {
    name: "EditAutoDeliveryCancelTooMuch",
    extends: SubInEdit,
    components: {
      CancelSubBtn,
      ActionButton,
      ColorCrewContact,
      SectionTitle,
      BackButton,
      SectionBlock
    },

    mixins: [zendeskTag],

    computed: {
      ...mapState('subscriptions', [
        'cancelData'
      ]),

      backUrl() {
        return `/dashboard/purchases/edit-auto-delivery/${this.$route.params.subId}/cancel-reasons`;
      }
    },

    methods: {
      ...mapActions('subscriptions', [
        'editAutoDeliveryChooseDateModal',
        'editAutoDeliveryPauseModal'
      ]),

      chooseShipDate() {
        this.trackEvent('Cancel flow choose ship date');
        this.editAutoDeliveryChooseDateModal();
      },

      pauseSub() {
        this.trackEvent('Cancel flow pause sub');
        this.editAutoDeliveryPauseModal();
      }
    },

    mounted() {
      if (!this.cancelData.reason.id) {
        this.$router.push({name: 'cancelReasons'});
      }

      if (this.cancelData.reason.tag) {
        this.zClick(this.cancelData.reason.tag);
      }
    }
  }

</script>

<style scoped lang="stylus">
  .section-title
    padding-bottom 2em

  .back-row
    margin-top 1.5em
    margin-left 1em

  .other-options
    max-width 26em
    margin 0 auto
    padding 0 0.5em

    >p
      padding 3em 0 2em

    button
      width 100%
      margin-bottom 0.8em

  .cancel-sub-btn
    padding 2em 0

</style>